import React, {useEffect, useState} from "react";
import {t} from "../../../shared-services/translate";
import BottomNotification from "./BottomNotification";
import UnavailableItemsList from "../../cart/Unavailable.ItemsList";
import UnavailableCTA from "../../cart/Unavailable.CTA";
import {useSelector} from "../../../shared-services/redux-tiny";

const BottomUnavailableItems = () => {
  const name = "BottomUnavailableItems";

  const {bottomNotification} = useSelector(state => state.topLayer);
  const [options, setOptions] = useState({});

  useEffect(() => {
    if (bottomNotification?.name === name) setOptions(bottomNotification?.options);
  }, [bottomNotification]);

  return <BottomNotification
    name={name}
    className={`
      padding-15
      padding-bottom-25
      background-color-white
      border-top-radius-xl
    `}
    style={{
      border: "2px solid #F65B2D"
    }}
  >
    <div className="margin-bottom-20 font-weight-900">
      {t("products.unavailable")}:
    </div>

    {options?.currentCart && <>
      <UnavailableItemsList order={options?.currentCart}/>
      <UnavailableCTA order={options?.currentCart} onRemove={options?.onRemove}/>
    </>
    }
  </BottomNotification>;
};

export default BottomUnavailableItems;
